/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

import { Page } from "commonAssets/pages/Page";
import { loading, outputDiv, i18n, siteInfoLang, appDomain } from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { createOfficialBanner } from "commonAssets/lib/officialBanner";
import { homePageModal, renderLegalOptionsTable } from "commonAssets/pages/Page/home";

const customHomePage = (params) => {
    console.log("[Home] ...");

    const slug = params.slug;
    const page = params.pages.find((sitePage) => sitePage.PageName === slug);
    const pageTitle = createElement(
        "h2",
        {
            class: "page-title mt-2 mb-4 d-none",
            "aria-label": i18n.getTranslation("home_page_aria_title"),
        },
        [],
        page.PageTitle
    );
    const pageBody = createElement("div", { class: "page-body" });
    const pageAlert = createElement(
        "div",
        {
            class: "alert border-dark bg-light text-dark mb-3 pt-4 text-center",
            id: "pageAlert",
        },
        [],
        page.PageAlert
    );
    const pageHeader = createElement(
        "p",
        { class: "text-center h2 my-5 pageHeader", id: "pageHeader_" + slug },
        [],
        page.PageHeader
    );
    const pageSubHeader1 = createElement(
        "p",
        {
            class: "text-center fw-bold fst-italic pageSubHeader1",
            id: "pageSubHeader1_" + slug,
        },
        [],
        page.PageSubHeader1
    );
    const pageSubHeader2 = createElement(
        "p",
        {
            class: "text-center fst-italic pageSubHeader2",
            id: "pageSubHeader2_" + slug,
        },
        [],
        page.PageSubHeader2
    );
    const divImptDates = createElement(
        "div",
        {
            class: "my-5 mx-auto",
            id: "ImportantDates",
            style: "max-width: 512px;",
        },
        [],
        params.dates.card()
    );
    const pageContent = createElement(
        "div",
        { class: "mb-3 pageContent", id: "pageContent_" + slug },
        [],
        page.PageContent
    );
    const pageFooter = createElement(
        "div",
        { class: "py-3", id: "pageFooter" },
        [],
        page.PageFooter
    );
    const bannerOpts = appDomain?.options?.officialBanner;
    const usePageLead =
        typeof bannerOpts === "object"
            ? bannerOpts.pageLead && bannerOpts.display !== false
            : false;

    const officialBanner = createOfficialBanner({
        i18n,
        siteInfoLang,
        appDomain,
        pageLead: usePageLead ? page.PageLead : null,
    });
    const optionsDIV = renderLegalOptionsTable(slug, page);
    const pageElement = createElement("div", { class: "page", id: slug }, [
        officialBanner,
        Boolean(page.PageAlert) ? pageAlert : "",
        pageHeader,
        pageSubHeader1,
        pageSubHeader2,
        createElement("div", { class: "row" }, [
            createElement("div", { class: "col-md-5" }, [divImptDates]),
            createElement("div", { class: "col-md-7" }, [
                createElement("div", { class: "text-center mt-5 mb-3" }, [
                    createElement("img", {
                        src: "https://angeion-public.s3.us-east-1.amazonaws.com/www.refrigeratorsettlement.com/docs/16df454f-7744-48fa-8c3e-b484847f12b5.jfif",
                        width: "600px",
                    }),
                ]),
                createElement("p", { class: "ms-5" }, [], "Example of broken wires in Whirlpool-, Maytag-, KitchenAid-, and JennAir-branded refrigerators (a “Wire Harness Issue”) that may impact in-door features such as the icemaker, ice dispenser, water dispenser, or control panel.")
            ]),
        ]),
        pageContent,
        createElement("p", { class: "mt-5 text-decoration-underline text-center" }, [], "<strong>SUMMARY OF AVAILABLE SETTLEMENT BENEFITS</strong>"),
        createElement("p", {}, [], "<strong>Options for Class Members with pre-existing Wire Harness Failures as of May 5, 2026:</strong>"),
        createElement("div", { class: "mb-5" }, [], `
           <div class="table-responsive optionsDIV" id="optionsPreexistingDIV_home"><table class="table table-bordered table-striped table-hover options my-3 optionsTABLE" id="optionsPreexistingTABLE_home"><thead><tr><th>Year of Failure</th><th>Cash Payment Option</th><th>Repair Option</th></tr></thead><tbody class="optionsTbody">
            <tr>
                <td>2-3</td>
                <td>50% of Original Purchase Price</td>
                <td>Free Replacement Door + Labor</td>
            </tr>
            <tr>
                <td>4</td>
                <td>40% of Original Purchase Price</td>
                <td>Free Replacement Door + Labor</td>
            </tr>
            <tr>
                <td>5</td>
                <td>40% of Original Purchase Price</td>
                <td>Free Replacement Door</td>
            </tr>
            <tr>
                <td>6-7</td>
                <td>30% of Original Purchase Price</td>
                <td>Free Replacement Door</td>
            </tr>
            <tr>
                <td>More than 7</td>
                <td>30% of Original Purchase Price</td>
                <td>Free Replacement Door</td>
            </tr>
           </tbody></table></div>
        `),
        createElement("p", { class: "mt-5" }, [], "<strong>Reimbursements for Class Members who previously paid to repair* a Wire Harness Issue before May 5, 2026:</strong>"),
        createElement("div", {}, [], `
           <div class="table-responsive optionsDIV" id="optionsPreexistingDIV_home"><table class="table table-bordered table-striped table-hover options my-3 optionsTABLE" id="optionsPreexistingTABLE_home"><thead><tr><th>Year of Failure</th><th>Percent of repair cost reimbursed <span class='text-decoration-underline'>with</span> prior notice to Whirlpool or retailer</th><th>Percent of repair cost reimbursed if <span class='text-decoration-underline'>no</span> prior notice to Whirlpool or retailer</th></tr></thead><tbody class="optionsTbody">
            <tr>
                <td>2-4</td>
                <td>75%</td>
                <td>65%</td>
            </tr>
            <tr>
                <td>5</td>
                <td>60%</td>
                <td>50%</td>
            </tr>
            <tr>
                <td>6-7</td>
                <td>45%</td>
                <td>35%</td>
            </tr>
           </tbody></table></div>
        `),
        createElement("p", { class: "mb-5", style: "font-size: 1rem;" }, [], "*Additionally, if the repair consisted of splicing wires, the Class Member is also entitled to a free replacement door plus labor if the failure occurred in years 2-4 or a free door  if the failure occurred in years 5-7."),
        createElement("p", { class: "mt-5" }, [], "<strong>Reimbursements for Class Members who previously paid to replace a Class Refrigerator due to a Wire Harness Issue before May 5, 2026:</strong>"),
        createElement("div", { class: "mb-5" }, [], `
           <div class="table-responsive optionsDIV" id="optionsPreexistingDIV_home"><table class="table table-bordered table-striped table-hover options my-3 optionsTABLE" id="optionsPreexistingTABLE_home"><thead><tr><th>Year of Failure</th><th>Percent of original purchase price reimbursed <span class='text-decoration-underline'>with</span> prior notice to Whirlpool or retailer</th><th>Percent of original purchase price reimbursed if <span class='text-decoration-underline'>no</span> prior notice to Whirlpool or retailer</th></tr></thead><tbody class="optionsTbody">
            <tr>
                <td>2-4</td>
                <td>50%</td>
                <td>45%</td>
            </tr>
            <tr>
                <td>5</td>
                <td>40%</td>
                <td>35%</td>
            </tr>
            <tr>
                <td>6-7</td>
                <td>30%</td>
                <td>25%</td>
            </tr>
           </tbody></table></div>
        `),
        createElement("p", { class: "mt-5" }, [], `<strong>Future Coverage in years 2-7 after purchase.</strong> To receive benefits for Wire Harness Issues that occur after May 5, 2026, before undertaking any repair or replacement you must contact Whirlpool at 1-844-667-2929 or <a href="mailto:refset2026@Whirlpool.com">refset2026@Whirlpool.com</a> within 90 days after you first experience the Wire Harness Issue to receive the repair benefit, or contact the Settlement Administrator at <a href="mailto:info@RefrigeratorSettlement.com">info@RefrigeratorSettlement.com</a> to receive a cash benefit.`),
        createElement("div", { class: "mb-5" }, [], `
           <div class="table-responsive optionsDIV" id="optionsPreexistingDIV_home"><table class="table table-bordered table-striped table-hover options my-3 optionsTABLE" id="optionsPreexistingTABLE_home"><thead><tr><th>Year of Failure</th><th>Cash Payment Option</th><th>Repair Option</th></tr></thead><tbody class="optionsTbody">
            <tr>
                <td>2-3</td>
                <td>50% of Original Purchase Price</td>
                <td>Free Replacement Door + Labor</td>
            </tr>
            <tr>
                <td>4</td>
                <td>40% of Original Purchase Price</td>
                <td>Free Replacement Door + Labor</td>
            </tr>
            <tr>
                <td>5</td>
                <td>40% of Original Purchase Price</td>
                <td>Free Replacement Door</td>
            </tr>
            <tr>
                <td>6-7</td>
                <td>30% of Original Purchase Price</td>
                <td>Free Replacement Door</td>
            </tr>
           </tbody></table></div>
        `),
        optionsDIV,
        pageFooter,
    ]);
    const pageDiv = createElement("div", { class: "home-container" }, [pageTitle, pageBody]);

    outputDiv.appendChild(pageElement);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 100);
};

export class customPage extends Page {
    home(render = customHomePage, plugin = []) {
        render(this);
        plugin.forEach((customPlugin) => customPlugin(this));
        homePageModal(this);
    }
}

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");
    // custom code goes here
    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // custom code goes here
    return claim;
}
